import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  toggle_off,
  toggle_on,
  view_icon,
} from "../../assets/img";
import { deletes, get, post, put } from "../../Services/ApiHandler";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { Table } from "../../components/Table/Table";

const CheckoutRewards = () => {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(false);

  const handleClosePop = () => {
    setSelected(false);
  };

  const handleChange = (key, val) => {
    setSelected((prev) => ({ ...prev, data: { ...prev?.data, [key]: val } }));
  };

  //api functions

  const getList = async () => {
    let res = await get(`${URLS.MASTERURL}?type=40`);
    if (res?.status === "success") {
      let d = res?.data?.map((item) => ({
        ...item,
        display_name: `${getOrdinal(Number(item?.name))} ${res?.data?.length === Number(item?.name) ? "& Above" : ""}`,
      }));
      setList(d);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleSubmit = async () => {
    let isAdd = selected?.type === "add";
    let url = isAdd
      ? `${URLS.MASTERURL}add/`
      : `${URLS.MASTERURL}${selected?.data?.id}/edit/`;
    let payload = isAdd
      ? {
          type: 40,
          position: list.length + 1,
          icon: selected?.data?.icon,
          name: selected?.data?.name,
        }
      : {
          icon: selected?.data?.icon,
          name: selected?.data?.name,
        };
    let res = await post(url, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList();
      handleClosePop();
    }
  };

  const handleStatus = async (d) => {
    let res = await post(`${URLS.MASTERURL}${d.id}/status/`, {
      status: !d.status,
      type: 40,
    });
    if (res?.status === "success") {
      toast.success("Language Status Updated");
      getList();
      handleClosePop();
    }
  };

  const handleDelete = async (data) => {
    let res = await post(`${URLS.MASTERURL}${data?.id}/delete/`);
    if (res?.status === "success") {
      setList((prev) => prev.filter((item) => item?.id != data?.id));
      toast.success(res?.message);
      handleClosePop();
    }
  };

  const getOrdinal = (number) => {
    const lastTwo = number % 100;

    if (lastTwo >= 11 && lastTwo <= 13) {
      return `${number}th`;
    }

    switch (number % 10) {
      case 1:
        return `${number}st time`;
      case 2:
        return `${number}nd time`;
      case 3:
        return `${number}rd time`;
      default:
        return `${number}th time`;
    }
  };

  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{row.index + 1}</p>;
        },
      },
      {
        Header: "Reward Time",
        accessor: "display_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Reward Amount",
        accessor: "icon",
        Cell: ({ value, row }) => {
          return <p className="">{String(value).padStart(2, 0)}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 ms-2`}
                style={{
                  fontSize: "12px",
                  opacity: 1,
                  cursor: "pointer",
                }}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js">
            <button
              onClick={() => setSelected({ type: "edit", data: row.original })}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>

            <button
              onClick={() => setSelected({ type: "view", data: row.original })}
              className="cust-btn"
            >
              <img src={view_icon} alt="" className="mx-2 edit-btn" />
            </button>
            <button
              onClick={() =>
                setSelected({ type: "delete", data: row.original })
              }
              className="cust-btn "
            >
              <img src={delete_icon} alt="" className="edit-btn" />
            </button>
          </div>
        ),
      },
    ];
  }, []);

  return (
    <div>
      <Topbar header={"Master"} back={true} />

      <div className="d-flex ac-jb">
        <div>
          <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22">
            Checkout Rewards
          </h2>
          <h2 className="f1 mt-1 fs-sm-8 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16">
            Total No: {String(list?.length).padStart(2, 0)}
          </h2>
        </div>
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() =>
              setSelected({ type: "add", data: { name: list?.length + 1 } })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add Rewards
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="mt-2">
        <Table
          columns={columns}
          setPageno={(page) => {}}
          data={list ?? []}
          show={true}
        />
      </div>

      {Boolean(
        selected?.type === "add" ||
        selected.type === "edit" ||
        selected?.type === "view",
      ) && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {selected?.type === "add"
                  ? "Add"
                  : selected?.type === "edit"
                    ? "Edit"
                    : "View"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  handleClosePop();
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div>
                  <div className="d-flex ac-jb">
                    <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                      Rewarded Time
                    </h3>
                    {/* <div className="d-flex ac-jb gap-2">
                      <p
                        style={{ color: "#6B7280" }}
                        className="f1 text-end fs-sm-8 fs-md-12 fs-lg-13 fs-xl-13 fs-xxl-14"
                      >
                        <i>Enable to final Reward</i>
                      </p>
                      <img
                        src={
                          Boolean(selected?.data?.toggle)
                            ? toggle_on
                            : toggle_off
                        }
                        style={{ height: "15px", width: "25px" }}
                        className=" pointer"
                        alt=""
                        onClick={() => {
                          handleChange(
                            "toggle",
                            !Boolean(selected?.data?.toggle),
                          );
                        }}
                      />
                    </div> */}
                  </div>
                  <input
                    type="number"
                    value={selected?.data?.name ?? ""}
                    onChange={(e) => {
                      handleChange("name", e.target.value);
                    }}
                    placeholder="Rewarded Time"
                    className="input-box mt-2"
                    disabled={true}
                  />
                  <h3 className="f4 text-start fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 mb-1 mt-3">
                    Reward Amount
                  </h3>
                  <input
                    type="number"
                    value={selected?.data?.icon ?? ""}
                    onChange={(e) => {
                      handleChange("icon", e.target.value);
                    }}
                    placeholder="Rewarded Amount"
                    className="input-box mt-2"
                  />
                </div>
              </div>
            </div>
            {selected?.type !== "view" && (
              <div className="d-flex ac-je px-2 mt-4">
                <button
                  onClick={handleSubmit}
                  className="submit-btn f2 w-40 p-2"
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(selected?.data?.active_video) && (
              <p className="text-danger mb-2 mt-2">
                This language has mapped videos.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => handleClosePop()}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutRewards;
